<template>
  <div class="list-box">
    <ul class="list-search">
      <li style="flex: 1"></li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        v-if="$judge_auth('8')"
        >添加</el-button
      >
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态/属性"
          sortable="status"
          width="100"
          align="center"
        >
          <template #default="{ row }">
            <div>
              <ul :style="{ color: row.status == 0 ? '#f00' : '#1e90ff' }">
                {{
                  row.status == 0 ? "离职" : "在职"
                }}
              </ul>
              <ul
                style="
                  color: #a2a2a2;
                  font-size: var(--tab-group-second-font-size);
                "
              >
                {{
                  row.property == 0 ? "雇员" : "其他"
                }}
              </ul>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="declare_status"
          sortable="declare_status"
          label="报送状态"
          width="100"
          align="center"
        >
          <template #default="{ row }">
            <el-tooltip
              effect="dark"
              :content="row.declare_msg"
              v-if="row.declare_msg"
            >
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  cursor: pointer;
                "
              >
                <c_status
                  arrName="employeedeclare_declare_status"
                  :value="row.declare_status"
                />
                <el-icon><QuestionFilled /></el-icon>
              </div>
            </el-tooltip>
            <c_status
              arrName="employeedeclare_declare_status"
              :value="row.declare_status"
              style="margin: 0 auto"
              v-else
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column
          label="扣缴义务人/税局"
          min-width="200"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.withholding_agent_name || '-',
                row.tax_bureau_name
              )
          "
        >
          <template #default="{ row }">
            <c_tabgroup :value2="row.tax_bureau_name">
              <template #top>
                <div
                  v-if="row.withholding_agent_id"
                  :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
                  :style="{
                    '--dynamic-color':
                      row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
                  }"
                  class="withholding-badge"
                  :title="row.withholding_agent_name"
                >
                  {{ row.withholding_agent_name }}
                </div>
                <text>-</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="所属客户/签约单位"
          :formatter="
            (row) =>
              $tab_GroupFormat(row.customer_name || '-', row.contract_unit_name)
          "
          min-width="200"
        />
        <el-table-column
          prop="skssq"
          label="税款所属期"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="name"
          label="入/离职时间"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.entry_time || '-',
                row.resignation_time || ''
              )
          "
          width="120"
          align="center"
        />
        <el-table-column prop="name" label="收款信息" min-width="200">
          <template #default="{ row }">
            <div style="display: flex; align-items: center; width: 100%">
              <el-tag
                v-if="row.diff_bank_status != 0"
                effect="dark"
                size="small"
                :type="row.diff_bank_status == 1 ? 'warning' : 'danger'"
                :title="
                  row.diff_bank_status == 1
                    ? '异卡发放审核中'
                    : '异卡审核已驳回'
                "
                style="cursor: pointer; margin-right: 5px"
              >
                {{ row.diff_bank_status == 1 ? "审" : "驳" }}
              </el-tag>
              <div
                style="flex: 1; overflow: hidden"
                v-html="
                  $tab_BuildGroup(row.opening_bank || '-', row.bank_account)
                "
              ></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="客服/创建时间"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.belonger_name + '/' + row.belonger_department_name,
                row.create_time
              )
          "
          min-width="160"
        />
        <el-table-column
          prop="update_time"
          label="更新时间"
          :formatter="$tab_TextFormat"
          width="120"
          align="center"
        />
        <el-table-column
          label="操作"
          width="220"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth('8')"
        >
          <template #default="{ row }">
            <!-- <el-button
              type="primary"
              link
              icon="Switch"
              title="更新至工资表"
              @click="onUpdate(row)"
              disabled
            >
              更新
            </el-button> -->
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              编辑
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showInfo"
      :title="(state.selectId ? '修改' : '添加') + '申报单位'"
      @close="state.showInfo = false"
    >
      <c_UnitInfo
        @close="
          state.showInfo = false;
          onLoad();
        "
        :id="state.selectId"
        :employee_id="props.employee_id"
      ></c_UnitInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  employee_applicationunit_list,
  employee_applicationunit_delete,
} from "@/http/employee";
import { confirm_func } from "@/utils/qFormat";

import c_UnitInfo from "./Info.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  components: {
    c_UnitInfo,
  },
  props: {
    employee_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.employee_id = props.employee_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      employee_applicationunit_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(employee_applicationunit_delete, id, onLoad);
    };
    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
    };
  },
};
</script>
<style scoped></style>
